import React from 'react';

import { LocationAutocompleteGoogle } from './LocationAutocompleteGoogle';

export function LocationAutocomplete(props) {
    return <LocationAutocompleteGoogle {...props} />;
}

// TODO: Fast-follow add basic rendering Storybook story when fixing eds-* global styles
